module.exports = [
  /*{
    title: 'Dashboard',
    url: 'Dashboard',
    icon: 'home'
  },*/
  {
    slug: 'packages',
    title: {de: 'Dashboard', en: 'Dashboard'},
    url: 'Page',
    index: 'packages-dashboard',
    icon: 'home'
  },
  {
    slug: 'orders',
    title: {
      de: 'Bestellungen',
      en: 'Orders'
    },
    url: 'Orders',
    subViews: [
      'OrderDetails'
    ],
    icon: 'inbox'
  },
  {
    slug: 'projects',
    title: {en: 'Drafts', de: 'Entwürfe'},
    url: 'Projects',
    index: 'tag:-Approval,status:0',
    subViews: [
      'ProjectDetails',
      'UploadStl'
    ],
    icon: 'cog',
    indicator: {
      api: 'project/',
      params: {
        tag: '-Approval',
        status: 0,
      }
    }
  },
  {
    slug: 'approvals',
    title: {en: 'Approvals', de: 'Freigabe'},
    url: 'Projects',
    index: 'tag:Approval,status:3',
    subViews: [
    ],
    icon: 'clipboard-check',
    indicator: {
      api: 'project/',
      params: {
        tag: 'Approval',
        status: 3,
      }
    }
  },
  {
    slug: 'addons',
    title: {
      de: 'Shop',
      en: 'Shop'
    },
    url: 'ProjectDetails',
    index: 'new:addons',
    icon: 'inbox'
  },
  {
    title: {
      de: 'Nachrichten',
      en: 'Messages',
    },
    url: 'Messages',
    icon: 'comments',
    indicator: {
      api: 'message/unread-count'
    }
  }
];
